// Core
import React, { useEffect } from "react"
import { isMobile } from "react-device-detect"
import { localiseString } from "../../utils/localiseString"

// Components
import ScrollSection from "../locomotiveScroll/scrollSection"
import Image from "../image"
import JsonText from "../_jsonText"
import { SlideMaskText } from "../slideMaskText"

// Style
import styles from "./playlist.module.scss"

// Images
import Spotify from "./images/spotify.inline.svg"

const Playlist = ({
  count,
  scrollEvent,
  contentful_id,
  menuTitle,
  bannerImage,
  heading,
  subheading,
  content,
  artworkGrid,
  spotifyUrl,
}) => {
  const anchorOverride = menuTitle
    ? menuTitle.replace(/\s+/g, "-").toLowerCase()
    : null

  useEffect(() => {
    setTimeout(() => {
      if (!isMobile && scrollEvent) {
        window.scroll.on("call", (value, way, obj) => {
          if (value === "playlist-" + contentful_id)
            scrollEvent(way, count, obj)
        })
      }
    }, 200)
  }, [])

  return (
    <React.Fragment>
      {bannerImage && <Image {...bannerImage} />}
      <ScrollSection>
        <div
          id={`ep-${anchorOverride ? anchorOverride : "playlist"}`}
          className={`${styles.wrap} container`}
          data-scroll
          data-scroll-call={`playlist-${contentful_id}`}
          data-scroll-offset="45%, 45%"
        >
          <div className={`cols flex`}>
            <div className={`col m12`}>
              <div className={styles.header}>
                <h3
                  className={styles.headerTitle}
                  data-scroll
                  data-scroll-speed="1"
                >
                  {heading}
                </h3>
                <p className={`mono`}>{subheading}</p>
              </div>
            </div>
            <div className={`${styles.contentCol} col m12 t5 d4`}>
              <div className={styles.content}>
                <JsonText {...content} />
              </div>
            </div>
            <div className={`${styles.artworkCol} col m10 tp8 t4 d3`}>
              <div className={styles.artwork}>
                {artworkGrid.map(data => {
                  return (
                    <img
                      src={data.fluid.src}
                      key={data.contentful_id}
                      width={432}
                      height={432}
                      alt={data.description}
                    />
                  )
                })}
              </div>
            </div>
            <div className={`col m12`}>
              <div className={styles.linkWrap}>
                <a
                  href={spotifyUrl}
                  target="_blank"
                  rel="noreferrer"
                  className={`${styles.link} button`}
                >
                  <SlideMaskText text={localiseString("Listen on Spotify")} />
                  <Spotify />
                </a>
              </div>
            </div>
          </div>
        </div>
      </ScrollSection>
    </React.Fragment>
  )
}

export default Playlist
